import { Record, Map } from 'immutable'

export const Inbox = Record({
  id: undefined,
  orgId: undefined,
  name: undefined,
  address: undefined,
  forwardAddress: undefined,
  status: undefined,
  createdAt: 0,
  totalConversationCount: 0,
  openConversationCount: 0,
  fetchStatus: undefined,
})

export const SendingDomain = Record({
  createdAt: undefined,
  domain: undefined,
  id: undefined,
  orgId: undefined,
  sendgridDkim: undefined,
  sendgridDkimStatus: undefined,
  status: undefined,
  updatedAt: undefined,
  sparkPostDkimStatus: undefined,
  sparkPostDkim: undefined,
})


export const Whitelabel = Map



// WEBPACK FOOTER //
// ./src/scripts/app/modules/inbox/models.js